<template>
  <div v-if="amountAndCurrency">
    <v-layout column ma-3 row :class="product.product.outOfStock ? 'opacity' : null">
      <v-layout>
        <v-layout column justify-center>
          <v-layout>
            <div v-if="coverImageUrl" class="cover mr-2">
              <placeholder-image :url="coverImageUrl" />
            </div>
            <v-layout column>
              <span class="product-name primary--text text--darken-1">{{ product.product.name }}</span>
              <span class="product-description">{{ product.product.shortDescription }}</span>
            </v-layout>
          </v-layout>
          <v-layout wrap v-if="amountAndCurrency.amount">
            <v-chip label class="mt-2 mr-2 px-2" color="primary lighten-2" :text-color="basePriceChipTextColor">
              {{ getPriceString({ amountAndCurrency: amountAndCurrency }) }}
            </v-chip>
            <v-chip v-if="showDisplayCurrency" label class="mt-2 px-2">
              {{ getPriceString({ amountAndCurrency: amountAndCurrency, displayCurrency: displayCurrency }) }}
            </v-chip>
          </v-layout>
        </v-layout>
        <span class="d-flex justify-end align-center">
          <amount-badge :amount="amountInCart" />
          <v-icon v-if="!product.product.outOfStock" color="grey darken-2" class="ml-2">mdi-chevron-right</v-icon>
        </span>
      </v-layout>
      <v-chip v-if="product.product.outOfStock" label class="ml-auto mt-2">{{$t('catalog.out_of_stock')}}</v-chip>
    </v-layout>
    <v-divider />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { textColor } from '@/lib/helpers/ColorUtils'
export default {
  data () {
    return {
      basePriceChipTextColor: textColor(this.$vuetify.theme.themes.light.primary.lighten2),
    }
  },
  computed: {
    ...mapState({
      state: (state) => state.state,
      cartProducts: (state) => state.cart.cartProducts,
      account: (state) => state.activityReservations.edited.account,
    }),
    ...mapGetters('me', ['getPriceString', 'showDisplayCurrency', 'displayCurrency']),
    amountInCart () {
      var amount = 0
      this.cartProducts
        .filter((cp) => {
          return cp.product.id === this.product.product.id
        })
        .forEach((item) => {
          amount += item.quantity
        })
      return amount
    },
    coverImageUrl () {
      return this.product.product.coverImageUrl
    },
    amountAndCurrency () {
      if (this.product.product.pricingGroupsWithPrices.length > 0) {
        var pricesByGroup = this.product.product.pricingGroupsWithPrices.find((pg) => {
          return pg.pricingGroupId === this.account.pricingGroupId
        })
        if (pricesByGroup) {
          return pricesByGroup.prices[0][0]
        } else {
          var pricingGroup = this.product.product.pricingGroupsWithPrices.find((pg) => {
            return pg.pricingGroupId === null
          })
          return (pricingGroup && pricingGroup.prices) ? pricingGroup.prices[0][0] : null
        }
      } else return null
    },
  },
  props: {
    product: Object,
  },
  components: {
    PlaceholderImage: () => import('@/components/app-components/PlaceholderImage.vue'),
    AmountBadge: () => import('@/components/view-components/catalog/AmountBadge.vue'),
  },
}
</script>

<style lang="scss">
.product-name {
  font-weight: bold;
  font-size: 18px;
}
.product-description {
  font-size: 16px;
}
.cover {
  min-width: 60px;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.v-btn__content {
  font-size: 13px !important;
}
</style>

<style lang="scss" scoped>
.opacity {
  opacity: 0.5;
}
</style>
